import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import MessagePanel from '../../../common/components/MessagePanel/MessagePanel';
import { Routes } from '../../../config/routes';
import { LinkDevicesContext } from '../../../providers/LinkDevicesContext';
import { ValidationContext } from '../../../providers/ValidationContext';
import withRouteAnalytics from '../../../services/analytics/withRouteAnalytics';
import { Screens } from '../../../services/analytics/screens';

function DeviceLinkedScreen(): JSX.Element {
  const { pendingStepsCompleted, pendingStepsFailed, clearCurrentLink } = useContext(LinkDevicesContext);
  const { getRouteForCurrentStatus } = useContext(ValidationContext);
  const navigate = useNavigate();

  const handleBack = () => {
    clearCurrentLink();
    navigate(-1);
  };

  // Monitor pending steps and navigate to upload complete if needed
  useEffect(() => {
    if (pendingStepsCompleted) {
      navigate(Routes.UPLOAD_COMPLETE);
    }
  }, [pendingStepsCompleted]);

  // Monitor if the pending steps went into a failed state and navigate tot the error screen if needed
  useEffect(() => {
    if (pendingStepsFailed) {
      // use validation context to route to appropriate error screen
      getRouteForCurrentStatus().then((route) => {
        if (route) {
          navigate(route);
        }
      });
    }
  }, [getRouteForCurrentStatus, navigate, pendingStepsFailed]);

  return (
    <MessagePanel
      title="screens.documentPass.linkDevices.titleLinked"
      description="screens.documentPass.linkDevices.keepOpen"
      dataTestId="DEVICES_LINKED"
      showSupportLink={false}
      showBack
      onBack={handleBack}
      showLoading
    />
  );
}
export default withRouteAnalytics(DeviceLinkedScreen, Screens.DOCUMENT_MOBILE_LINKED_MOBILE);
